// https://vuex.vuejs.org/en/mutations.html
import * as TYPES from './mutations-types'
import { userDataStorageKey } from '../../../config'

/* eslint-disable no-param-reassign */
export default {
  [TYPES.SET_TOKEN](state, value) {
    state.token = value
  },
  [TYPES.SET_USER](state, value) {
    state.user = value
    // Guard: don't overwrite the cached metadata on logout / empty payloads.
    // We deliberately keep the previous user-data blob in localStorage so the
    // next login can present a warm cache (decision: "Keep across users").
    if (!value || !value.metadata) {
      return
    }
    try {
      localStorage.setItem(userDataStorageKey, JSON.stringify(value))
    } catch (e) {
      // ignore quota / serialisation errors — login must not fail because of them
    }
  },
}
